import Repository from './Repository';

const resource = '/itens-avaliacao';

export default {
  get(id) {
    return Repository.get(`${resource}/${id}`);
  },

  getAllByAvaliacao(avaliacao) {
    return Repository.get(`${resource}/avaliacao/${avaliacao}`);
  },

  getAllByDiagnostico(diagnostico, tipo, perspectiva) {
    return Repository.get(`${resource}/diagnostico/${diagnostico}?tipo=${tipo}&perspectiva=${perspectiva}`);
  },

  create(itens) {
    return Repository.post(`${resource}/`, itens);
  },

  update(payload) {
    return Repository.put(`${resource}/${payload.id}`, payload);
  },

  delete(id) {
    return Repository.delete(`${resource}/${id}`);
  },
};
